<template>
    <modal name="declaration-detail-modal" class="declaration-detail-modal"
           :width="650"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_title">신고 내용</div>
        <div class="pl30 pr30 pb30">
            <div class="modal_content">
                {{declarationData.bb_reason}}
            </div>
            <div class="modal_img">
                <img v-for="img in declarationData.File" :key="`img${img.a_idx}`" :src="`${img.org_url}`">
            </div>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="closeModal()">학인</el-button>
                <el-button class="com_btn" @click="movePage()">바로가기</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";
export default {
    name: "DeclarationDetailModal",
    mixins: [],
    components: {},
    inject: {

    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            declarationData:{}
        }
    },
    created() {
    },
    mounted() {


    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {

        handlerBeforeOpen(event) {
            this.declarationData = event.params.declarationData;
        },
        handlerBeforeClose() {
            this.$router.replace(this.$route.path);
        },
        closeModal() {
            this.$modal.hide('declaration-detail-modal')
        },
        movePage(){
            let type ='';
            if (this.declarationData.bb_type === 0) {
                type= 'live'
            } else if (this.declarationData.bb_type === 1) {
                type= 'endlive'
            } else if (this.declarationData.bb_type === 2) {
                type= 'post'
            } else if (this.declarationData.bb_type === 3) {
                type= 'post';
            }
            this.$router.push(`/jst/board/${type}/${this.declarationData.board_id}`)
        }
    },
    watch: {
    },
}
</script>

<style scoped>

</style>
